module.exports = __webpack_public_path__ + "static/media/pic2.13e6546d.jpg";